import "react";
import { jsx } from "react/jsx-runtime";
//#region src/components/DistanceHumanReadable/index.tsx
/**
* Displays a distance in human-readable imperial units (feet/miles)
*
* Conversion:
* - 1 meter = 3.28084 feet
* - 1 mile = 1609.344 meters
* - 1 mile = 5280 feet
*
* Display logic:
* - < 0.1 miles (528 feet): Show in feet
* - >= 0.1 miles: Show in miles with decimal
*/
function DistanceHumanReadable({ distanceMeters, precision = 1 }) {
	const METERS_PER_MILE = 1609.344;
	const FEET_PER_METER = 3.28084;
	const MILE_THRESHOLD = .1;
	const miles = distanceMeters / METERS_PER_MILE;
	const feet = Math.round(distanceMeters * FEET_PER_METER);
	let displayValue;
	if (miles < MILE_THRESHOLD) displayValue = `${feet} ft`;
	else displayValue = `${miles.toFixed(precision)} mi`;
	return /* @__PURE__ */ jsx("span", { children: displayValue });
}
DistanceHumanReadable.displayName = "Distance";
//#endregion
export { DistanceHumanReadable };

//# sourceMappingURL=index.js.map